import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfPoint, PdfBrush } from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import { calcOrigin } from '../../core/genHelper';
import '../../pdf/draw/primitives';
import '../../pdf/draw/label';

export class Rybicky implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 1;
  }
  countMax(): number {
    return 50;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const margin = PdfUnit.FromMillimeters(5);
    const { origin, size } = calcOrigin(2, 5, margin, PdfSize.A4);

    const colors = GUtil.randomBrushes(opts.data.random, [
      [
        '#bafed9',
        '#a9fece',
        '#91fec3',
        '#82f8bd',
        '#82f0b9',
        '#82e8b5',
        '#82dfb1',
        '#89dbb1',
        '#99e4bb',
        '#a6ecc6',
      ],
      [
        '#a4edce',
        '#a5ebc5',
        '#a5e9bd',
        '#a6e7b5',
        '#a6e5ad',
        '#a6e4a4',
        '#aee1a3',
        '#b5e0a2',
        '#b8de96',
        '#badc89',
      ],
      [
        '#effbd9',
        '#f5f7d4',
        '#f3edcc',
        '#eee3c2',
        '#e7e6c4',
        '#d9e0c2',
        '#cadabd',
        '#cdd9cb',
        '#d8e5e5',
        '#d2e1f2',
      ],
      [
        '#eaf4c5',
        '#dbdfbb',
        '#e0e2c2',
        '#e8ecca',
        '#e9ebc4',
        '#e1e6bf',
        '#d2ddbd',
        '#e9eed5',
        '#fcfde6',
        '#f4f8df',
      ],
    ]);

    const pageCount = Math.ceil(opts.list.length / 10);

    for (let p = 0; p < pageCount; p++) {
      const page = pdf.addPage();
      const startIndex = p * 10;
      const endIndex = Math.min(startIndex + 10, opts.list.length);
      const pageItems = opts.list.slice(startIndex, endIndex);

      const r0Size = new PdfSize(size.width * 0.5, size.height * 0.7);
      const labelFont = page.adjustFontMulti(
        pageItems.map((item) => [item.left.getText() ?? '']),
        GUtil.baseFont,
        r0Size
      );

      for (let x = 0; x < 2; x++) {
        for (let y = 0; y < 5; y++) {
          const indexOnPage = x * 5 + y;
          if (indexOnPage >= pageItems.length) continue;

          const item = pageItems[indexOnPage];
          const colorIndex = (p * 10 + indexOnPage) % colors.length;

          const rect = new PdfRect(
            origin.x + x * size.width,
            origin.y + y * size.height,
            size.width - PdfUnit.FromMillimeters(2),
            size.height - PdfUnit.FromMillimeters(2)
          );

          const r1 = new PdfRect(rect.left, rect.top, rect.width * 0.8, rect.height);
          const r0 = new PdfRect(
            rect.left + rect.width * 0.15,
            rect.top + rect.height * 0.15,
            rect.width * 0.5,
            rect.height * 0.7
          );

          const e0 = new PdfRect(
            rect.left + rect.width * 0.12,
            rect.top + rect.height * 0.18,
            rect.width * 0.1,
            rect.width * 0.1
          );
          const e1 = new PdfRect(
            rect.left + rect.width * 0.16,
            rect.top + rect.height * 0.25,
            rect.width * 0.05,
            rect.width * 0.05
          );

          const d = rect.height * 0.1;
          const points = [
            new PdfPoint(rect.centerX, rect.centerY),
            new PdfPoint(rect.right, rect.top + d),
            new PdfPoint(rect.right, rect.bottom - d),
          ];

          page.drawEllipse(null, colors[colorIndex], r1);
          page.drawPolygon(null, colors[colorIndex], points);
          page.drawLabel(item.left, { rect: r0, font: labelFont });
          page.drawEllipse(null, PdfBrush.White, e0);
          page.drawEllipse(null, PdfBrush.Black, e1);
          page.drawEllipse(GUtil.basePen, null, e0);
        }
      }
    }
  }
}
